<template>
  <div class="blogs">
    <hero v-if="!isInApp" />
    <trending-articles
      :blogs="filteredArticles"
      :loading="loading"
      :bookMarks="bookMarks"
      :follwedBloggers="followedBloggers"
      @bookMarkBlog="toggleBookMark"
      @followBlogger="toggleFollowBlogger"
    />
    <div class="horizontal-line"></div>
    <blogs-grid
      :blogs="filteredArticles"
      :loading="loading"
      :tools="tools"
      :tags="tags"
      :bookMarks="bookMarks"
      :connections="connections"
      @bookMarkBlog="toggleBookMark"
    />
    <br /><br />
    <Form />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "@/components/layout/Form";
import Hero from "@/components/other-pages/Blogs/Hero";
import TrendingArticles from "@/components/other-pages/Blogs/TrendingArticles";
import BlogsGrid from "@/components/other-pages/Blogs/BlogsGrid";

export default {
  name: "Blog",
  data() {
    return {
      loading: false,
      tools: [],
      bookMarks: [],
      connections: [],
      followedBloggers: [],
      tags: [],
      logo: "https://journeybinder.com/img/main_logo.39bf51d2.png"
    };
  },
  components: {
    Hero,
    Form,
    TrendingArticles,
    BlogsGrid
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      articles: "listings/blogs"
    }),
    filteredArticles() {
      if (this.$route.params.focus) {
        if (this.$route.params.focus == "Spiritual") {
          return this.articles.filter(blog => blog.doc.spheres.includes("s"));
        } else if (this.$route.params.focus == "Health") {
          return this.articles.filter(blog => blog.doc.spheres.includes("h"));
        } else if (this.$route.params.focus == "Education") {
          return this.articles.filter(blog => blog.doc.spheres.includes("e"));
        } else if (this.$route.params.focus == "Finance") {
          return this.filter(blog => blog.doc.spheres.includes("f"));
        }
      }
      return this.articles;
    },
    isInApp() {
      return this.$route.fullPath
        ? this.$route.fullPath.includes("/app")
        : false;
    }
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue.uid) {
        this.getBookMarks();
        this.getFollowedBloggers();
        this.getTags();
      }
    }
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    this.$store.dispatch("listings/getListBlogs").then(blogs => {
      this.loading = false;
    });

    this.$store.dispatch("listings/getListTools").then(tools => {});
    if (this.user) {
      this.getBookMarks();
      this.getFollowedBloggers();
    }
    setTimeout(() => {
      this.getTags();
    }, 1000);
  },
  methods: {
    getTags() {
      if (!this.user) {
        /*let tags = JSON.parse(Cookies.get("blog_tags"))
        if(tags.length > 0){
          this.tags = tags
        }*/
      } else {
        this.$store.dispatch("user/getBlogTags").then(tags => {
          this.tags = tags;
        });
      }
    },
    getBookMarks() {
      this.$store
        .dispatch("user/getUserBlogBookMarks", this.user.uid)
        .then(bookMarks => {
          this.bookMarks = bookMarks;
        });
    },
    getFollowedBloggers() {
      this.$store
        .dispatch("user/getFollowedBloggers", this.user.uid)
        .then(bloggers => {
          this.followedBloggers = bloggers;
          console.log(this.followedBloggers);
        });
    },
    toggleBookMark(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (data.type == "add") {
          this.$store.dispatch("user/addBookMarkBlog", data.blog).then(() => {
            this.getBookMarks();
            console.log("Bookmarked");
          });
        } else {
          this.$store
            .dispatch("user/removeBookMarkBlog", data.blog)
            .then(() => {
              this.getBookMarks();
              console.log("Removed bookmark");
            });
        }
      }
    }, //@TODO make this a mixin
    toggleFollowBlogger(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (data.type == "follow") {
          this.$store.dispatch("user/followBlogger", data.blogger).then(() => {
            this.getFollowedBloggers();
            console.log("Followed");
          });
        } else {
          this.$store
            .dispatch("user/unfollowBlogger", data.blogger)
            .then(() => {
              this.getFollowedBloggers();
              console.log("Unfollowed");
            });
        }
      }
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:title", content: "Our Daily Focus" },
        {
          name: "twitter:description",
          content: "The Blog of JourneyBinder.com"
        },
        // image must be an absolute path
        { name: "twitter:image", content: this.logo },
        // Facebook OpenGraph
        { property: "og:title", content: "Our Blog" },
        { property: "og:site_name", content: "Our Daily Focus" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: "The Blog of JourneyBinder.com" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.blogs {
  position: relative;
  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  padding-top: 72px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }

  .horizontal-line {
    border-top: 1px solid #ddd;
  }
}
</style>
